import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { bindComponentViewModel } from '../../../../../../shared/utils/component-view-model.util';

@Component({
    selector: 'app-developer-property-edit-stepper',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './developer-property-edit-stepper.component.html',
    styleUrls: ['./developer-property-edit-stepper.component.scss']
})
export class DeveloperPropertyEditStepperComponent {

    currentStep: any;
    goToStep: any;
    steps: any;
    private _vm: any;

    @Input({ required: true })
    set vm(value: any) {
        this._vm = value;
        bindComponentViewModel(this, value, ['_vm']);
    }

    get vm(): any {
        return this._vm;
    }
}
